export default __webpack_public_path__ + "static/media/(5).e697b2c7.jpg";